document.addEventListener("DOMContentLoaded", (event) => {
    const searchIcon = document.querySelector(".searchIcon")

    searchIcon.addEventListener("click", () => {
        setTimeout(() => {
            const searchBar = document.getElementById("search_hidden")
            searchBar.focus()
        }, 100)
    });    
  });